import scrollingWindowFromTo from '@utils/scrollingWindowFromTo';
import * as types from './types';

export const initTabs = () => ({
  type: types.INIT,
});

export const triggerChangeTabs = (payload, id, isRemove) => ({
  type: types.TRIGGER_CHANGE_TABS,
  payload: scrollingWindowFromTo(payload),
  id,
  isRemove,
});

export const triggerAddTab = payload => ({
  type: types.TRIGGER_ADD_TAB,
  payload: scrollingWindowFromTo(payload),
});

export const triggerUpdateTab = (payload, id, removeHasChanged) => ({
  type: types.TRIGGER_UPDATE_TAB,
  payload: scrollingWindowFromTo(payload),
  id,
  removeHasChanged,
});

export const triggerRemoveTab = (id, msg) => ({
  type: types.TRIGGER_REMOVE_TAB,
  id,
  msg,
});

export const triggerReplaceTab = (payload, fromId, toId) => ({
  type: types.TRIGGER_REPLACE_TAB,
  payload: scrollingWindowFromTo(payload),
  fromId,
  toId,
});

export const removeBackgroundTab = (id) => ({
  type: types.REMOVE_BACKGROUND_TAB,
  id,
});
